module.exports = __webpack_public_path__ + "static/banner-865c6f2fe7da2c5a71a74e81cb17649c.jpg";